var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getCookie } from "../../helpers/cookies";
var LoadstoneService = {
    postLoadstone: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var _c;
        var productId = _b.productId, recomBlockId = _b.recomBlockId, type = _b.type;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _c = type;
                    switch (_c) {
                        case "recomAddToBasket": return [3 /*break*/, 1];
                        case "recomTap": return [3 /*break*/, 3];
                        case "addToBasket": return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 7];
                case 1: return [4 /*yield*/, showLoadstoneApi({
                        metodo: type,
                        productId: productId,
                        recomBlockId: recomBlockId,
                    })];
                case 2:
                    _d.sent();
                    return [3 /*break*/, 7];
                case 3: return [4 /*yield*/, showLoadstoneApi({
                        metodo: type,
                        productId: productId,
                        recomBlockId: recomBlockId,
                    })];
                case 4:
                    _d.sent();
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, showLoadstoneApi({ metodo: type, productId: productId })];
                case 6:
                    _d.sent();
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); },
};
var showLoadstoneApi = function (newBody) { return __awaiter(void 0, void 0, void 0, function () {
    var rcuid, response, addToBasketResponse, err_1, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                rcuid = getCookie("rcuid");
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch("/index.php?ctrl=index&act=procesarLoadStoneApi", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(__assign({ rcuid: rcuid }, newBody)),
                    })];
            case 2:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 3:
                addToBasketResponse = _a.sent();
                return [2 /*return*/, addToBasketResponse];
            case 4:
                err_1 = _a.sent();
                error = "ERROR_ADD_TO_BASKET";
                return [2 /*return*/, error];
            case 5: return [2 /*return*/];
        }
    });
}); };
export default LoadstoneService;
